import { ColorType } from './color-types.model';

export interface ColorOptions {
  allowColorPicker?: boolean;
  colorPalette?: ColorType[];
  colorPickerColumnDef?: string;
}
